require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ecso-public-outreach.json") })
        }
      }, "path---ecso-public-outreach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ecso-public-outreach!./.cache/json/ecso-public-outreach.json
// module id = 885
// module chunks = 231608221292675